<template>
  <b-modal
    ref="modalUpgradeConfirmation"
    dialog-class="!max-w-[600px]"
    body-class="!p-[32px] text-black w-full text-center"
    size="lg"
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
  >
    <img
      src="https://storage.googleapis.com/komerce/assets/svg/Icon-Warning.svg"
      alt="Warning"
      class="mx-auto mb-[16px]"
    >
    <b-button
      variant="ghost"
      class="absolute top-[10px] right-[1px] !text-[32px] text-[#292D32] rotate-45"
      @click="handleCancel"
    >
      <span class="k-add" />
    </b-button>
    <h4 class="mb-[16px] text-[24px] font-semibold text-[#333333]">
      Ubah Status Kreator?
    </h4>
    <p class="mb-[18px] text-[#626262]">
      Kamu akan mengubah status kreator ini. Perubahan ini akan memengaruhi akses, visibilitas, dan aktivitas yang dapat dilakukan oleh kreator di platform.
    </p>
    <p class="mb-[24px] text-[#626262]">
      Apakah kamu yakin ingin melanjutkan?
    </p>
    <div class="flex justify-center items-center gap-[12px]">
      <b-button
        variant="outline-primary"
        class="w-full"
        @click="handleCancel"
      >
        Batal
      </b-button>
      <b-button
        variant="primary"
        class="w-full !flex items-center justify-center gap-[8px]"
        :disabled="loading"
        @click="submitModal"
      >
        <b-spinner
          v-if="loading"
          small
        />
        Ya, Ubah Status
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalUpgradeConfirmation',
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.callback = null
    this.cancelFn = null
  },
  methods: {
    /**
     * Tampilkan modal konfirmasi dan simpan callback upgrade status
     * @param {{ callback: () => Promise<unknown>, onCancel: () => void }} options
     */
    showModal({ callback, onCancel }) {
      this.callback = callback
      this.cancelFn = onCancel
      this.$refs.modalUpgradeConfirmation.show()
    },
    /** Tutup modal dan hapus callback terdaftar */
    closeModal() {
      this.callback = null
      this.cancelFn = null
      this.loading = false
      this.$refs.modalUpgradeConfirmation.hide()
    },
    handleCancel() {
      this.cancelFn()
      this.closeModal()
    },
    /** Jalankan callback upgrade status setelah user konfirmasi */
    async submitModal() {
      this.loading = true
      try {
        await this.callback()
        this.closeModal()
        this.$toast_success({ message: 'Status kreator berhasil diubah.' })
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengubah status kreator. Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
